module.exports = __webpack_public_path__ + "static/img/bg-function-3.22f50e19.png";